export default {
    newObject(source) {
        let object = {}
        for(let key in source) {
            object[key] = source[key]
        }
        return object
    },
    newArray(source) {
        let object = []
        for(let key in source) {
            let s = source[key]
            object[key] = s
        }
        return object
    },
    extractAllByKey (items, key) {
        let all = false
        if (undefined !== key) {
            for (let i in items) {
                let item = items[i]
                if (undefined !== item[key]) {
                    if (all === false) {
                        all = []
                    }
                    all.push(item[key])
                }
            }
        }
        return all
    },
    findAllByKey (items, key, value) {
        let all = false
        if (undefined !== value && undefined !== key) {
            for (let i in items) {
                let item = items[i]
                if (undefined !== item[key]) {
                    if (item[key].toString() === value.toString()) {
                        if (all === false) {
                            all = []
                        }
                        all.push(item)
                    }
                }
            }
        }
        return all
    },
    findByKey (items, key, value) {
        if (undefined !== value && undefined !== key) {
            for (let i in items) {
                let item = items[i]
                if (undefined !== item[key]) {
                    if (item[key].toString() === value.toString()) {
                        return item
                    }
                }
            }
        }
        return false
    },
    findIndexByKey (items, key, value) {
        if (undefined !== value && undefined !== key) {
            for (let i in items) {
                let item = items[i]
                if (undefined !== item[key]) {
                    if (item[key].toString() === value.toString()) {
                        return i
                    }
                }
            }
        }
        return false
    },
    removeByKey (items, key, value) {
        if (undefined !== value && undefined !== key) {
            for (let i in items) {
                let item = items[i]
                if (undefined !== item[key]) {
                    if (item[key].toString() === value.toString()) {
                        return items.splice(i, 1)
                        break;
                    }
                }
            }
        }
        return false
    }
}